import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Boleto } from "../interfaces/entities/Boleto";

export const getDadosCadastroBoletoDigital = async (): Promise<Boleto | null> => {
    try {
        const response = await apiClientes.get('Financeiro/GetDadosCadastroBoletoDigital',{
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });
        return response.data; // Retornar o valor da resposta, não a resposta completa

    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const cadastrarBoletoDigital = async (idCadastro: string ,tel: string, email1: string, email2: string, email3: string): Promise<any> => {
    try {
        const response = await apiClientes.post('Financeiro/CadastrarBoletoDigital', {
            idCadastro,
            tel,
            email1,
            email2,
            email3
        }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};

export const cancelarBoletoDigital = async (idCadastro: string): Promise<any> => {
    try {
        const response = await apiClientes.post('Financeiro/CancelarBoletoDigital', {
            idCadastro
        }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};